import {
  DashboardMenuItem,
  Menu,
  ResourceMenuItem,
  usePermissions,
  useRedirect,
  useResourceDefinitions,
  useSidebarState,
} from "react-admin";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RedeemIcon from "@mui/icons-material/Redeem";
import SettingsIcon from "@mui/icons-material/Settings";
import BusinessIcon from "@mui/icons-material/Business";
import BuildIcon from "@mui/icons-material/Build";
import ShieldIcon from "@mui/icons-material/Shield";
import { useEffect, useState } from "react";
import { PERMISSION_TEMPLATE } from "./utils/permissions.constants";

const MENU_STATE_DEFAULT = { settings: false, tools: false, other: false };

export const CustomMenu = () => {
  const resources = useResourceDefinitions();
  const [open, setOpen] = useSidebarState();
  const [menuState, setMenuState] = useState(MENU_STATE_DEFAULT);
  const { permissions } = usePermissions();

  const settingsResources = Object.keys(resources)
    .filter((name) => resources[name].hasList && resources[name].options?.parent === "settings")
    .map((name) => ({
      name,
      label: resources[name].options?.label || name,
    }));

  const toolsResources = Object.keys(resources)
    .filter((name) => resources[name].hasList && resources[name].options?.parent === "tools")
    .map((name) => ({
      name,
      label: resources[name].options?.label || name,
    }));

  const otherResources = Object.keys(resources)
    .filter(
      (name) =>
        resources[name].hasList &&
        resources[name].options?.parent !== "settings" &&
        resources[name].options?.parent !== "tools"
    )
    .map((name) => ({
      name,
      label: resources[name].options?.label || name,
    }));
  useEffect(() => {
    if (open) {
    } else {
      setMenuState(MENU_STATE_DEFAULT);
    }
  }, [open]);

  const handlerChange = (expanded, accordion) => {
    setMenuState({ ...menuState, [accordion]: expanded });
    if (expanded) {
      setOpen(true);
    }
  };

  const profile = JSON.parse(localStorage.getItem("profile"));
  const branchId = permissions !== "admin-sucursal" ? null : profile.branch._id;
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true); // opcional
  const [error, setError] = useState(null); // opcional
  const redirect = useRedirect();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const profile = JSON.parse(localStorage.getItem("profile") || "{}");
        const token = localStorage.getItem("token");

        if (!profile._id || !token) {
          throw new Error("Falta ID de usuario o token");
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/profile/${profile._id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        setUserData(data.data); // o data directamente, depende de tu API
      } catch (err) {
        console.error("Error al traer datos:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);
  useEffect(() => {
    if (!userData || loading) return;
    if (userData?.role === "admin-sucursal") {
      const permissions = userData.permissions || PERMISSION_TEMPLATE;
      // Función para encontrar la primera ruta permitida
      const findFirstAllowedRoute = (permissions) => {
        if (permissions.Tablero) return "/";
        if (permissions.Configuraciones?.Servicios) return "/service";
        if (permissions.Configuraciones?.Disponibilidad) return "/availabilityWeb";
        if (permissions.Configuraciones?.Empleados) return "/employee";
        if (permissions.Configuraciones?.Sucursal) return `/branch/${userData.branch?._id}`;
        if (permissions.Configuraciones?.Tutorial) return "/tutorial";
        if (permissions.Herramientas?.Clientes) return "/enterprise/customers";
        if (permissions.Herramientas?.Reservas) return "/booking";
        if (permissions.Herramientas?.Balance) return "/bookingBalance";
        if (permissions.Herramientas?.Calendario) return "/schedule";
        if (permissions.Herramientas?.HorarioNoDisponible) return "/unavailability";
        if (permissions.Herramientas?.Cupones) return "/coupon";
        if (permissions.Herramientas?.Beneficios) return "/airtable";
        return "/";
      };

      const firstAllowedRoute = findFirstAllowedRoute(permissions);
      redirect(firstAllowedRoute);
    }
  }, [userData, loading]);

  const isSucursal = userData?.role === "admin-sucursal";
  const permissionsObject = userData?.permissions || {};

  const canViewTablero = !isSucursal || permissionsObject.Tablero === true;

  const configPerms = permissionsObject.Configuraciones || {};
  const toolsPerms = permissionsObject.Herramientas || {};
  const hasAnyConfig = !isSucursal || Object.values(configPerms).some((v) => v);
  const hasAnyTool = !isSucursal || Object.values(toolsPerms).some((v) => v);
  // console.log("hasAnyConfig", hasAnyConfig);
  // console.log("hasAnyTool", hasAnyTool);
  // console.log('LENGTHSETTINGS', settingsResources.length)
  const hasPermission = (key, fallback = true) => {
    if (userData?.role !== "admin-sucursal") return true;
    return userData?.permissions?.Configuraciones?.[key] || userData?.permissions?.Herramientas?.[key] || false;
  };
  return (
    <Menu>
      {canViewTablero && <DashboardMenuItem key="default-dashboard-menu-item" />}
      {hasAnyConfig && (
        <Accordion
          expanded={menuState.settings}
          onChange={(event, expanded) => handlerChange(expanded, "settings")}
          style={{
            height: "fit-content",
            transition: "none",
            border: "none",
            borderColor: "transparent",
            boxShadow: "none",
            margin: 0,
            overflow: "hidden",
          }}
        >
          <AccordionSummary
            expandIcon={open ? <ExpandMoreIcon /> : null}
            sx={{ margin: 0, "&:hover": { backgroundColor: (theme) => theme.palette.action.hover } }}
          >
            <Grid
              container
              alignItems="center"
              spacing={1}
              sx={{
                marginTop: 0,
                display: "flex",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <Grid
                item
                style={{
                  margin: 0,
                  padding: 0,
                  paddingLeft: "0.5rem",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
                color="primary.menuIcon"
              >
                <SettingsIcon />
              </Grid>
              {open && (
                <Grid item style={{ margin: 0, padding: 0 }}>
                  <Typography>Configuraciones</Typography>
                </Grid>
              )}
            </Grid>
          </AccordionSummary>
          <AccordionDetails
            style={{ padding: "0px 16px" }}
            sx={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}
          >
            <>
              {settingsResources.map((resource) => (
                <ResourceMenuItem key={resource.name} name={resource.name} label={resource.label} />
              ))}
              {permissions === "admin-sucursal" && hasPermission("Sucursal") && (
                <Menu.Item to={`/branch/${branchId}`} primaryText="Sucursal" leftIcon={<BusinessIcon />} />
              )}
              {/* <Menu.Item to="/tutorial" primaryText="Tutorial" leftIcon={<OndemandVideoIcon />} /> */}
              {(permissions !== "admin-sucursal" || hasPermission("Tutorial")) && (
                <Menu.Item to="/tutorial" primaryText="Tutorial" leftIcon={<OndemandVideoIcon />} />
              )}
            </>
          </AccordionDetails>
        </Accordion>
      )}

      {hasAnyTool && toolsResources.length > 0 && (
        <Accordion
          expanded={menuState.tools}
          onChange={(event, expanded) => handlerChange(expanded, "tools")}
          style={{
            height: "fit-content",
            transition: "none",
            border: "none",
            borderColor: "transparent",
            boxShadow: "none",
            margin: 0,
            overflow: "hidden",
          }}
        >
          <AccordionSummary
            expandIcon={open ? <ExpandMoreIcon /> : null}
            sx={{ margin: 0, "&:hover": { backgroundColor: (theme) => theme.palette.action.hover } }}
          >
            <Grid
              container
              alignItems="center"
              spacing={1}
              sx={{ marginTop: 0, display: "flex", alignItems: "center", gap: "1rem" }}
            >
              <Grid
                item
                style={{
                  margin: 0,
                  padding: 0,
                  paddingLeft: "0.5rem",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
                color="primary.menuIcon"
              >
                <BuildIcon />
              </Grid>
              {open && (
                <Grid item style={{ margin: 0, padding: 0 }}>
                  <Typography>Herramientas</Typography>
                </Grid>
              )}
            </Grid>
          </AccordionSummary>
          <AccordionDetails
            style={{ padding: "0px 16px" }}
            sx={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              position: "relative",
              flexShrink: 0,
            }}
          >
            <>
              {toolsResources.map((resource) => (
                <ResourceMenuItem key={resource.name} name={resource.name} label={resource.label} />
              ))}
              {(permissions !== "admin-sucursal" || hasPermission("Beneficios")) && (
                <Menu.Item to="/airtable" primaryText="Beneficios" leftIcon={<RedeemIcon />} />
              )}
            </>
          </AccordionDetails>
        </Accordion>
      )}

      {otherResources.length > 0 && (
        <Accordion
          expanded={menuState.other}
          onChange={(event, expanded) => handlerChange(expanded, "other")}
          style={{
            height: "fit-content",
            transition: "none",
            border: "none",
            borderColor: "transparent",
            boxShadow: "none",
            margin: 0,
            overflow: "hidden",
          }}
        >
          <AccordionSummary
            expandIcon={open ? <ExpandMoreIcon /> : null}
            sx={{ margin: 0, "&:hover": { backgroundColor: (theme) => theme.palette.action.hover } }}
          >
            <Grid
              container
              alignItems="center"
              spacing={1}
              sx={{ marginTop: 0, display: "flex", alignItems: "center", gap: "1rem" }}
            >
              <Grid
                item
                style={{
                  margin: 0,
                  padding: 0,
                  paddingLeft: "0.5rem",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
                color="primary.menuIcon"
              >
                <ShieldIcon />
              </Grid>
              <Grid item style={{ margin: 0, padding: 0 }}>
                {open && <Typography>Más opciones</Typography>}
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails style={{ padding: "0px 16px" }}>
            <>
              {otherResources.map((resource) => (
                <ResourceMenuItem key={resource.name} name={resource.name} label={resource.label} />
              ))}
            </>
          </AccordionDetails>
        </Accordion>
      )}
    </Menu>
  );
};
